import React from 'react'
import ForgotPasswordForm from './ForgotPasswordForm'
import Column from '../generic/Column'
import { Link } from 'react-router-dom'

const ForgotPasswordBox = (props) => {
  return (
    <Column className='is-4 is-offset-4 box app-login-box'>
      <ForgotPasswordForm />
      <br />
      <div>
        <Link to='/'>Voltar ao login</Link>
      </div>
    </Column>
  )
}

export default ForgotPasswordBox



// WEBPACK FOOTER //
// ./src/components/forgot-password/ForgotPasswordBox.js